$(document).ready(function(){

   var isALARendered;
function ALAcheck() {
  isALARendered = setInterval(function () {
    customALA()
  }, 200);
}
ALAcheck();
function customALA() {
var selector = $('.addon-product');
  if(selector.length > 0) {
  $(".addon-product").each(function(){
  $(this).find("h4").on("click", function(){
    $("h4").removeClass("active");
    $(this).addClass("active");
    $("body").addClass("custom_drwer");
    $(".addon-product").find(".custom_drawer").addClass("hidden");
    $(this).closest(".addon-product").find(".custom_drawer").removeClass("hidden");
  });
});
    
        $(document).on('change', '.bundleCheck', function () {
      const $group = $(this).closest('ul[name="addon-variant"]');
      
      // Reset all buttons in group
      $group.find('li').removeClass('checked').each(function () {
        const defaultPrice = $(this).find('.button--block').attr("data-price") || "Free";
        $(this).find('.without_addon').text("Choose | Free");
        $(this).find('.with_addon').text("Choose | " + defaultPrice);
      });
      const $currentLi = $(this).closest('li');
      $currentLi.addClass('checked');
      const selectedTitle = $currentLi.attr('data-vTitle');
      $(".block-swatch.s_variant.active").text(selectedTitle);
      $currentLi.find('.without_addon').text("selected");
      $currentLi.find('.with_addon').text("selected ");
    });
  }  
}


  $(document).on('click', '.button--block', function () {
  const $this = $(this);
  if ($this.text().trim().includes("Choose")) {
    cloase_drawer(); // Make sure function name is correct
  }
  const $radio = $this.siblings('input[type="radio"]');
  $radio.prop('checked', true).trigger('change');
});



  function cloase_drawer(){
    $(".addon-product").find(".custom_drawer").each(function(){
      $(this).addClass("hidden");
       $("body").removeClass("custom_drwer");
      $(".block-swatch").removeClass("custom_drwer");
    });
  }

  $(document).on("click",'.close-icon',function(){
    cloase_drawer();
  });
  
  $(document).on("click",'.bg-overlay',function(){
    cloase_drawer();
  });



  // atc bundle 

$('.template-multi_product form.shopify-product-form .buy-buttons button').on('click', function(e) {
  e.preventDefault();
  console.log("btn_click");
  var timestemp = Date.now();

  var items = [];
  $('ul[name="addon-variant"]').each(function() {
    const selectedRadio = $(this).find('li.checked input.bundleCheck');
    if (selectedRadio.length > 0) {
      const variantId = parseInt(selectedRadio.data('vid'));
      const variantLabel = $(this).parents(".addon-product").data('vtitle');
      const variantTitle = selectedRadio.data('value');
      const quantity = 1;
      

      // Add separate addon product
      items.push({ 
        id: variantId, 
        quantity: quantity, 
        properties: { _addon: "free" , _bundle_group_id: timestemp } 
      });
    }
  });

const mainVariant = parseInt($('.template-multi_product form.shopify-product-form [name="id"]').val());
const mainQty = 1;

let addonProperties = {};
let addonIndex = -1;
let usedLabels = new Set();

$('.addon-product').each(function(index) {
  let pro_label = $(this).data("vtitle")?.trim();
  const pro_val = $(this).find(".block-swatch.s_variant").text().trim();

  // Generate a label if missing or already used
  if (!pro_label || usedLabels.has(pro_label)) {
    pro_label = `Addon ${addonIndex}`;
  }

  // Store in properties
  addonProperties[pro_label] = pro_val;

  // Track used labels
  usedLabels.add(pro_label);
  addonIndex++;
});


console.log("addonProperties:--", addonProperties);
console.log("mainQty:--",mainQty);
console.log("mainVariant:--",mainVariant);


if (mainVariant && mainQty > 0) {
  items.unshift({
    id: mainVariant,
    quantity: mainQty,
    properties: {
      ...addonProperties,
      _bundle_group_id: timestemp
    }
  });
}

  console.log("Final items to add:", items);

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ items })
  })
  .then(res => res.json())
  .then(data => {
    console.log('Added to cart:', data);
    document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:open'));
  const checkoutButton = document.querySelector('a[href="/cart"]');
      const clickEvent = new MouseEvent('click', { bubbles: true, cancelable: true, view: window }); 
    setTimeout(function(){
      checkoutButton.dispatchEvent(clickEvent);
      },1500);
  })
  .catch(err => console.error('Error adding to cart:', err));
});
  

    // remove bundle  
// $(document).on('click', 'a.cart__remove-button_cstm', function () {
//    setTimeout(() => {
//    var  $this = $(this);
//   var variantId = $($this).attr("data-variant_id");
//   const timestamp = $($this).data("timestamp");
//   let item_qty = parseInt($($this).siblings(".quantity-selector__input").attr("value"));
//   item_qty =  0
//   if (!timestamp) return;

//   // Disable button to prevent double-clicks
//   $($this).addClass("disabled");

//   // Delay slightly to avoid race conditions
 
//     $.getJSON('/cart.js', function (cart) {
//       const updates = {};

//       cart.items.forEach(function(item) {
//         const bundleGroupId = item.properties?._bundle_group_id;
//         if (bundleGroupId && bundleGroupId == timestamp) {
//           if(item.id != variantId)
//           {
//             updates[item.key] = item_qty;
//           }
//         }
//       });

//       if (Object.keys(updates).length === 0) {
//         console.warn("No matching bundle items found.");
//         $($this).removeClass("disabled");
//         return;
//       }
//       console.log('updates',updates);
//         // fetch('/cart/update.js', {
//         //   method: 'POST',
//         //   headers: {
//         //     'Content-Type': 'application/json'
//         //   },
//         //   body: JSON.stringify({ updates })
//         // })
//         // .then(res => {
//         //   if (!res.ok) throw new Error(`HTTP ${res.status}`);
//         //   return res.json();
//         // })
//         // .then(data => {
//         //   console.log('Cart updated:', data);
//         //   document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
//         // })
//         // .catch(err => {
//         //   console.error('Error updating cart:', err);
//         // });
//     });
//   }, 500); // Small delay to avoid timing issues
// });

  


 // add + bundle 

//   $(document).on('click', 'a.addon-plus-icon', function () {
//   var  $this = $(this);
//     console.log("hhhh");
//     setTimeout(function(){
//   var variantId = $($this).attr("data-variant_id");
//   const timestamp = $($this).attr("data-timestamp");
//   let item_qty = parseInt($($this).siblings(".quantity-selector__input").attr("value"));
//     // console.log("variantId:--",variantId);
//  item_qty =  item_qty + 1;
//   if (!timestamp) return;

//   $($this).addClass("disabled");
//     $.getJSON('/cart.js', function (cart) {
//       const updates = {};

//       cart.items.forEach(function(item) {
//         const bundleGroupId = item.properties?._bundle_group_id;
//         if (bundleGroupId && bundleGroupId == timestamp) {
//           if(item.id != variantId)
//           {
//             updates[item.key] = item_qty ;
//           }
//         }
//       });
//       if (Object.keys(updates).length === 0) {
//         console.warn("No matching bundle items found.");
//         $($this).removeClass("disabled");
//         return;
//       }
//       // fetch('/cart/update.js', {
//       //   method: 'POST',
//       //   headers: {
//       //     'Content-Type': 'application/json'
//       //   },
//       //   body: JSON.stringify({ updates })
//       // })
//       // .then(res => {
//       //   if (!res.ok) throw new Error(`HTTP ${res.status}`);
//       //   return res.json();
//       // })
//       // .then(data => {
//       //   console.log('Cart updated:', data);
//       //   document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
//       // })
//       // .catch(err => {
//       //   console.error('Error updating cart:', err);
//       // });
//     });
//       },1000);
// });

 // remove - bundle 
// $(document).on('click', 'a.addon-minus-icon', function () {
//   var  $this = $(this);
//     setTimeout(function(){
//     var variantId = $($this).attr("data-variant_id");
//     const timestamp = $($this).data("timestamp");
//     let item_qty = parseInt($($this).siblings(".quantity-selector__input").attr("value"));
//     item_qty =  item_qty - 1;
  
//   if (!timestamp) return;

//   $($this).addClass("disabled");
//     $.getJSON('/cart.js', function (cart) {
//       const updates = {};

//       cart.items.forEach(function(item) {
//         const bundleGroupId = item.properties?._bundle_group_id;
//         if (bundleGroupId && bundleGroupId == timestamp) {
//           if (item.quantity > 1 ) {
//              if(item.id != variantId)
//             {
//               updates[item.key] = item_qty ;
//             }
//           } else {
//             // Optional: set to 0 if you want to remove when quantity reaches 1
//             // updates[item.key] = 0;
//             console.warn(`Item ${item.key} already at minimum quantity`);
//           }
//         }
//       });

//       if (Object.keys(updates).length === 0) {
//         console.warn("No matching bundle items found.");
//         $($this).removeClass("disabled");
//         return;
//       }
//       // fetch('/cart/update.js', {
//       //   method: 'POST',
//       //   headers: {
//       //     'Content-Type': 'application/json'
//       //   },
//       //   body: JSON.stringify({ updates })
//       // })
//       // .then(res => {
//       //   if (!res.ok) throw new Error(`HTTP ${res.status}`);
//       //   return res.json();
//       // })
//       // .then(data => {
//       //   console.log('Cart updated:', data);
//       //   document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
//       // })
//       // .catch(err => {
//       //   console.error('Error updating cart:', err);
//       // });
//     });
//   },1000);
// });

// change on input qty.
//   $(document).on('change', '.quantity-selector__input__cstm', function (e) {
//    var  $this = $(this);
//     // console.log("hhhh");
//     // setTimeout(function(){
//   var item_qty_updated =  parseInt($(this).val());
//   var variantId = parseInt($($this).attr("data-variant_id"));
//   var timestamp = parseInt($($this).attr("data-timestamp"));
//       console.log("item_qty_updated:----",item_qty_updated);
//     // console.log("variantId:--",variantId);
//   if (!timestamp) return;
//     if(timestamp){
//       e.preventDefault();
//     }

//   $($this).addClass("disabled");
//     // $.getJSON('/cart.js', function (cart) {
//     //   const updates = {};

//     //   cart.items.forEach(function(item) {
//     //     var bundleGroupId = item.properties?._bundle_group_id;
//     //     if (bundleGroupId && bundleGroupId == timestamp) {
//     //       if(item.id != variantId)
//     //       {
//     //         updates[item.key] = item_qty_updated ;
//     //       }
//     //     }
//     //   });
//     //   if (Object.keys(updates).length === 0) {
//     //     console.warn("No matching bundle items found.");
//     //     $($this).removeClass("disabled");
//     //     return;
//     //   }
//     //   console.log('updates',updates);
//     //   fetch('/cart/update.js', {
//     //     method: 'POST',
//     //     headers: {
//     //       'Content-Type': 'application/json'
//     //     },
//     //     body: JSON.stringify({ updates })
//     //   })
//     //   .then(res => {
//     //     if (!res.ok) throw new Error(`HTTP ${res.status}`);
//     //     return res.json();
//     //   })
//     //   .then(data => {
//     //     console.log('Cart updated:', data);
//     //     document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
//     //   })
//     //   .catch(err => {
//     //     console.error('Error updating cart:', err);
//     //   });
//     // });
//       // },1000);
// });


  
const maxInitial = 3;

// Add Initial block
$(".add_more_initial").on("click", function () {
  const currentInitials = $(".pro_1").length;

  if (currentInitials < maxInitial) {
    const newBlock = $(".pro_1").first().clone(true, true);
    
    // Reset the state
    newBlock.find("input[type=radio]").prop("checked", false);
    newBlock.find("li").removeClass("checked");
    
    newBlock.find(".button--block").each(function () {
      const price = $(this).attr("data-price") || "Free";
      $(this).find(".without_addon").text("Choose | Free");
      $(this).find(".with_addon").text("Choose | " + price);
    });

    // Add remove button if not already present
    if (newBlock.find(".remove-addon").length === 0) {
      newBlock.append('<button class="remove-addon" type="button" style="position:absolute; top:5px; right:5px; background:transparent; border:none; font-size:18px; cursor:pointer;">×</button>');
      newBlock.css("position", "relative"); // Ensure parent has relative position
    }

    // Append the new block
    newBlock.appendTo(".addon_main_pro_2");

    // Hide add button if max reached
    if ($(".pro_1").length >= maxInitial) {
      $(".add_more_initial").hide();
    }
  }
});

// Remove Initial block
$(document).on("click", ".remove-addon", function () {
  $(this).closest(".pro_1").remove();

  // Re-show add button if under limit
  if ($(".pro_1").length < maxInitial) {
    $(".add_more_initial").show();
  }
});



$(".add_more_birthstone").on("click", function () {
  const currentInitials = $(".pro_2").length;

  if (currentInitials < maxInitial) {
    const newBlock = $(".pro_2").first().clone(true, true);
    console.log("newBlock:----",newBlock);
    // Reset the state
    newBlock.find("input[type=radio]").prop("checked", false);
    newBlock.find("li").removeClass("checked");
    
    newBlock.find(".button--block").each(function () {
      const price = $(this).attr("data-price") || "Free";
      $(this).find(".without_addon").text("Choose | Free");
      $(this).find(".with_addon").text("Choose | " + price);
    });

    // Add remove button if not already present
    if (newBlock.find(".remove-addon-sec").length === 0) {
      newBlock.append('<button class="remove-addon-sec" type="button" style="position:absolute; top:5px; right:5px; background:transparent; border:none; font-size:18px; cursor:pointer;">×</button>');
      newBlock.css("position", "relative"); // Ensure parent has relative position
    }

    // Append the new block
    newBlock.appendTo(".addon_main_pro_2");

    // Hide add button if max reached
    if ($(".pro_2").length >= maxInitial) {
      $(".add_more_birthstone").hide();
    }
  }
});

// Remove Initial block
$(document).on("click", ".remove-addon-sec", function () {
  $(this).closest(".pro_2").remove();

  // Re-show add button if under limit
  if ($(".pro_2").length < maxInitial) {
    $(".add_more_birthstone").show();
  }
});




  
});